import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class UserVarifyService {
    constructor(
        private httpService: HttpService) { }

    //验证用户资金密码
    //chen 2017-01-04
    getUserVarify(bankPassW: string) {
        let url = AppConfig.GetProdUrl() + "/User/VarifyBankPassword?bankPassword=" + bankPassW;
        let param = { "bankPassword": bankPassW };
        return this.httpService.post(url, param);
    }

    //查询可否提现
    //chen 2017-01-04
    getCashEnable() {
        let url = AppConfig.GetProdUrl() + "/Index/QueryCashEnable";
        return this.httpService.get(url);
    }

    //查询剩余提现次数
    //chen 2017-01-04
    getCashTime() {
        let url = AppConfig.GetProdUrl() + "/Index/QueryRemainCashTime";
        return this.httpService.get(url);
    }

    //提交提现申请
    //chen 2017-01-04
    getDrawMoney(moneyPwd: string, money: string, bankId: Number) {
        let param = "moneyPwd=" + moneyPwd + "&money=" + money + "&bankId=" + bankId;
        let url = AppConfig.GetProdUrl() + "/Index/WithDrawMoney";
        return this.httpService.get(url + "?" + param);
    }
    //获取提现手续费
    //david 2019-04-03
    getServiceCharge() {
        let url = AppConfig.GetProdUrl() + "/Index/GetWithdrawSetting";
        return this.httpService.get(url);
    }
    //查询用户余额
    //chen 2017-01-04
    getUserMoney() {
        let url = AppConfig.GetProdUrl() + "/User/GetUserMoney";
        return this.httpService.get(url);
    }

    //获取所有密保问题
    //TQQ 2017-06-06
    getSecurityQuestions() {
        let url = AppConfig.GetProdUrl() + "/User/GetSecurityQuestions";
        return this.httpService.get(url);
    }

    //判断是否设置密保
    //TQQ 2017-06-06
    ckkUserSecurityQuestion() {
        let url = AppConfig.GetProdUrl() + "/User/CheckUserSecurityQuestion";
        return this.httpService.get(url);
    }
    //设置密保
    //TQQ 2017-06-06
    setSecurityInfo(question) {
        let url = AppConfig.GetProdUrl() + "/User/SetUserSecurityInfo";
        return this.httpService.post(url, question);
    }

    //验证密保是否正确
    //TQQ 2017-05-03
    ckUserQuestion(question) {
        let url = AppConfig.GetProdUrl() + "/Log/CkUserQuestion";
        return this.httpService.post(url, question);
    }

    //获取密保问及答案
    //TQQ 2017-05-03
    getMiBaoQuestion(name) {
        let url = AppConfig.GetProdUrl() + "/Log/forgetPwdck";
        return this.httpService.post(url, name);
    }

    //修改资金密码
    //TQQ 2017-05-02
    updateBankPwd(bankpwd) {
        let url = AppConfig.GetProdUrl() + "/User/Funds";
        return this.httpService.post(url, bankpwd);
    }

    //获取谷歌登录器二维码图片
    getQrCodeImg() {
        let url = AppConfig.GetProdUrl() + "/auth/QrCodeImg";
        return this.httpService.get(url);
    }
    //添加谷歌登录器
    //TQQ 2017-05-11
    addGasecret(params) {
        let url = AppConfig.GetProdUrl() + "/User/AddGasecret";
        return this.httpService.get(url, params);
    }
    //获取谷歌登录器二维码
    //TQQ 2017-05-11
    getGaSecret() {
        let url = AppConfig.GetProdUrl() + "/User/GetGaSecret";
        return this.httpService.get(url);
    }
    //验证是否设置资金密码
    //chen 2017-03-14
    getCheckCreateMoney(params) {
        var url = AppConfig.GetProdUrl() + "/User/CheckBankPassword";
        return this.httpService.post(url, params);
    }
    //   判断是否设置资金密码
    ckBankPassword(params) {
        let url = AppConfig.GetProdUrl() + "/User/CheckBankPassword";
        return this.httpService.post(url, params);
    }
}




// WEBPACK FOOTER //
// ./src/services/userVarify.service.ts